import React from 'react';

const NotFound = () => <h1 style={{ textAlign: 'center' }}>Not found</h1>;

export default NotFound;
